import { makeStyles } from "tss-react/mui";

import { colors } from "@/theme/overrides/colors";

const fontSize = {
  body: "16px",
  callout: "15px",
  caption: "10px",
  label: "11px",
  overline1: "12px",
};

const lineHeight = {
  body: "20.08px",
  callout: "18.83px",
  caption: "12.55px",
  label: "13.81px",
  largeTitle: "41.42px",
  overline1: "15.06px",
};

export const useTypographyStyles = makeStyles()({
  // base
  textRegular: {
    fontFamily: "Mulish",
    fontWeight: 600,
    color: colors.mapped.surface.default,
    cursor: "pointer",
    ":hover": {
      color: colors.mapped.surface.hover,
    },
    ":active": {
      color: colors.mapped.surface.active,
    },
  },
  textBold: {
    fontFamily: "Mulish",
    fontWeight: 400,
    color: colors.mapped.surface.default,
    cursor: "pointer",
    ":hover": {
      color: colors.mapped.surface.hover,
    },
    ":active": {
      color: colors.mapped.surface.active,
    },
  },
  //   typography
  body: {
    fontSize: fontSize.body,
    lineHeight: lineHeight.body,
  },
  callout: {
    fontSize: fontSize.callout,
    lineHeight: lineHeight.callout,
  },

  label: {
    fontSize: fontSize.label,
    lineHeight: lineHeight.label,
  },
  caption: {
    fontSize: fontSize.caption,
    lineHeight: lineHeight.caption,
  },
  overline1: {
    fontSize: fontSize.overline1,
    lineHeight: lineHeight.overline1,
  },
});
